import ArrowIcon from '@mui/icons-material/ArrowCircleRightOutlined';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from 'components/Button/Button';
import React from 'react';
import { useTranslation } from 'react-i18next';
import * as Styled from './styled';

const PromoText = ({}) => {
  const [t] = useTranslation('auth');
  return (
    <Styled.ReviewContainer>
      <Box className="embedsocial-reviews">
        <img
          style={{ marginBottom: 16, borderRadius: 12 }}
          className="img-fluid"
          src={t('login_promo_img_url')}
        />
        <Box>
          <Typography gutterBottom variant="h4">
            {t('login_promo_title')}
          </Typography>
          <Typography paragraph color="text.secondary">
            {t('login_promo_subtitle')}
          </Typography>
          <Button
            className="cta"
            component="a"
            href={t('login_promo_cta_url')}
            target="_blank"
            endIcon={<ArrowIcon />}
          >
            {t('login_promo_cta_text')}
          </Button>
        </Box>
      </Box>
    </Styled.ReviewContainer>
  );
};

export default PromoText;
